import classnames from 'classnames';

import { useLoadingState } from '@hh.ru/magritte-common-use-loading-state';
import { ActionProps } from '@hh.ru/magritte-ui-action/types';
import { IncompleteSkeletonComponent, Skeleton } from '@hh.ru/magritte-ui-skeleton';

import styles from './action.less';

export const ActionSkeleton: IncompleteSkeletonComponent<ActionProps> & { isAction: true } = ({
    Component: Action,

    // skeleton props
    width,
    height,
    borderRadius,
    inline,
    additionalClass,
    loading,

    ...actionProps
}) => {
    const isLoading = useLoadingState() || loading;

    if (isLoading) {
        return (
            <div
                className={classnames(styles.actionSkeletonContainer, {
                    [styles.actionSkeletonDisablePadding]: actionProps.disablePadding,
                })}
            >
                <Skeleton
                    additionalClass={classnames(styles.actionSkeleton, {
                        [styles.actionSkeletonShowBackground]:
                            actionProps.showBackground && !actionProps.disablePadding,
                    })}
                />
            </div>
        );
    }

    return <Action {...actionProps} />;
};

ActionSkeleton.isAction = true;
